<template>
  <div>
    <base-modal
      hide-close-button
      @close="close"
    >
      <template #heading>
        We've Improved Our Terms of Service!
      </template>
      <div class="d-flex flex-column modal-content">
        <div>
          We've made updates to our
          <a
            href="https://hikeseo.co/terms-conditions/"
            target="_blank"
          >Terms of Service</a> to include our latest feature, the Onsite Optimizer, and other improvements that enhance your Hike experience.
        </div>
        <div class="mt-2">
          Please take a moment to review the updated Terms of Service. By clicking “OK”, you agree to the new terms.
        </div>
      </div>
      <template #footer>
        <button
          class="ml-auto btn primary_btn btn_sm"
          @click="close"
        >
          OK
        </button>
      </template>
    </base-modal>
  </div>
</template>
<script>
import BaseModal from "@/components/global/modals/BaseModal";
import {mapActions} from "vuex";

export default {
  components: {
    BaseModal
  },
  props: {
    currentTosVersion: {
      type: Number,
      required: true
    }
  },
  emits: ['modal:close'],
  data() {
    return {
      processingRequest: false
    }
  },
  methods: {
    ...mapActions('user', [
      'updateTermsOfService'
    ]),
    async close() {
      if (this.processingRequest) {
        return;
      }

      this.processingRequest = true;
      await this.updateTermsOfService(this.currentTosVersion);
      this.processingRequest = false;
    },
  }
}
</script>

<style scoped>
.modal-content {
  font-size: 1rem;
}
</style>
